import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import { Button, Box } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { useHistory } from "react-router-dom";
import axios from 'axios';
import swal from 'sweetalert';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import FormGroup from '@mui/material/FormGroup';
import FormHelperText from '@mui/material/FormHelperText';

const AddWorkshopJoinAsCategory = () => {
    const history = useHistory();
    const [disabled, setDisabled] = useState(false);
   
    const eventName = localStorage.getItem('eventname');
    const eventid = localStorage.getItem('eventid')
    const [dyamicField, setDynamicField] = useState([{ w_field_name: "", w_category_price: "" }]);
    const [addWorkShopJoinAs, setAddWorkShopJoinAs] = useState({
        event_name: eventName,
        w_join_as: "",
       
    });
    
   

    const handleInput = (e) => {
        e.persist();
        setAddWorkShopJoinAs({ ...addWorkShopJoinAs, [e.target.name]: e.target.value });
    }

   

  

    // const joinAsCateSubmit = (e) => {

    //     e.preventDefault();

    //     const data = {
    //         eventid,
    //         event_name: addWorkShopJoinAs.event_name,
    //         workshop_join_as: addWorkShopJoinAs.w_join_as,
           
          

    //     }

    //     console.log(data)
    //     // data.event_name == "" ? setdisabled(false) :
    //     //     data.w_join_as == "" ? setdisabled(false) :
    //     //         //setdisabled(true)

    //     axios.get('/sanctum/csrf-cookie').then(response => {

    //         axios.post(`/api/workshop-particpant-join-as/${eventid}`, data).then(res => {

    //             if (res.data.status === 200) {


    //                 swal('Success', res.data.message, 'success');

    //                 history.push('/admin/workshop/particpant');
    //             }
    //             else {

    //                 setAddWorkShopJoinAs({ ...addWorkShopJoinAs, error_list: res.data.validate_error })

    //             }

    //         });


    //     });


    // }
    const joinAsCateSubmit = (e) => {
        e.preventDefault();
    
        const data = {
            eventid,
            event_name: addWorkShopJoinAs.event_name,
            workshop_join_as: addWorkShopJoinAs.w_join_as,
        };
    
        console.log(data);
    
        // Disable button if either event_name or workshop_join_as is empty
        if (data.event_name === "" || data.workshop_join_as === "") {
            setDisabled(true);
            return;  // Exit the function if validation fails
        } else {
            setDisabled(false);
        }
    
        axios.get('/sanctum/csrf-cookie')
            .then(response => {
                axios.post(`/api/workshop-particpant-join-as/${eventid}`, data)
                    .then(res => {
                        if (res.data.status === 200) {
                            swal('Success', res.data.message, 'success');
                            history.push('/admin/workshop/particpant');
                        } else {
                            setAddWorkShopJoinAs({ 
                                ...addWorkShopJoinAs, 
                                error_list: res.data.validate_error 
                            });
                        }
                    })
                    .catch(err => {
                        console.error("Error in submission: ", err);
                        swal('Error', 'Failed to submit data. Please try again.', 'error');
                    });
            })
            .catch(err => {
                console.error("Error in CSRF token retrieval: ", err);
            });
    };
    
    const [abstractHomeSetup, setAbstractHomeSetup] = useState({
        color_code: "",
        color_code_two: "",
        color_code_three: "",
        call_emergency: "",
        send_email: "",
        event_place: "",
        facebook_link: "",
        Instagram_link: "",
        linkedin_link: "",
        twitter_link: "",
        abstractFooterImage: "",
        abstractBannerImage: "",
        abstractSponserLogos: "",
        error_list: [],
    });
    React.useEffect(() => {
        axios.get(`api/add-home-setup-index?id=${eventid}`).then(res => {
            if (res.status === 200) {
                const getHomePageData = res.data.HomePageSetup;
                setAbstractHomeSetup(getHomePageData);
            }
        })
    
    }, [eventid]);
    
    
    
    let backGroundButtonByEvent = "";
    if (eventid) {
        backGroundButtonByEvent = `${abstractHomeSetup.color_code_two}`; // Assign the value conditionally
    }
    else {
        backGroundButtonByEvent = '#145348'; // Default background color
    }
    //backgroundColor: backGroundButtonByEvent,
  return (
    <div style={{ margin: '1%', width: '60vw', marginLeft: '10%' }}>
    <Box sx={{ color: '#000000', }} style={{ marginTop: '5%' }}>
        <h4 sx={{ m: 2, color: '#000000' }} >
            <Button sx={{
                float: 'right',
                marginTop: '2%',
                backgroundColor: backGroundButtonByEvent,
                ":hover": {
                    color: "white"
                }
            }}
                
                size='small'
                variant='contained'
                onClick={() => history.goBack()}>
                Back
            </Button>
        </h4>
        <Card sx={{ width: '60vw', float: 'center' }} >
            <CardContent >
                <Typography component="h1" variant="h5">
                    Add WorkShop Join As
                </Typography>
                <Box component="form" onSubmit={joinAsCateSubmit} noValidate sx={{ mt: 3 }}>
                    <Grid container spacing={4}>
                        <Grid item xs={6} >
                            <TextField
                                disabled
                                autoComplete="given-name"
                                required
                                fullWidth
                                label="Evnet Name"
                                autoFocus
                                name='event_name' onChange={handleInput}
                                defaultValue={eventName || ""} />
                        </Grid>
                        

                        <Grid item xs={6} >
                            <TextField
                                autoComplete="given-name"
                                required
                                fullWidth
                                label="Join As"
                                autoFocus
                                name='w_join_as' onChange={handleInput}
                                />
                        </Grid>


                    </Grid>

                    <Grid container justifyContent="flex-end">
                        <Button
                            disabled={disabled}
                            type="submit"
                            // fullWidth
                            variant="contained"
                            sx={{ mt: 5, backgroundColor: backGroundButtonByEvent,}} >
                            Add WorkShop Join As
                        </Button>
                    </Grid>
                </Box>
            </CardContent>
        </Card>
    </Box>
</div>
  );
}

export default AddWorkshopJoinAsCategory;
